// extracted by mini-css-extract-plugin
export default {"questionRow":"AppraisalReviewSection_questionRow__7E+Iq"};